import { Box, TextField } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import TkSelectForm from "../../components/atoms/TkSelectForm";
import TkDatePicker from "../../components/atoms/TkDatePicker";
import TkButton from "../../components/atoms/TkButton";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { TkGetCodeList } from "../../utils/TkGetCode";
import {
  FacilityKbnList1,
  FacilityKbnList2,
  InquiryResultDisplayType,
  MembershipStatusList1,
  MembershipStatusList2,
} from "../../assets/data/Constants";
import { useNavigate } from "react-router-dom";
import { BusinessContext } from "../../context/businessContext";
import TkSuperPowerText from "../../components/molecules/TkSuperPowerText";
import dayjs from "dayjs";

/**
 * SCRW120001 検索画面
 * @return SCRW120001 検索画面
 */
const SCRW120001 = () => {
  const navigate = useNavigate();
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [errorList, setErrorList] = useState<any>({
    contractorNo: "",
    contractorAddress: "",
    contractorNameKana: "",
    contractorName: "",
    contractorTel: "",
    contractorFax: "",
    facilityNo: "",
    facilityAddress: "",
    facilityName: "",
    staffNo: "",
    staffName: "",
    staffBirthday: "",
    membershipDateFrom: "",
    membershipDateTo: "",
  });
  // 契約者情報
  const [contractorCondition, setContractorCondition] = useState<any>({
    contractorNo: "",
    contractorAddress: "",
    contractorNameKana: "",
    contractorName: "",
  });
  // 施設情報
  const [facilityCondition, setFacilityCondition] = useState<any>({
    facilityNo: "",
    facilityAddress: "",
    facilityName: "",
  });

  // 制度改正前新設
  const [isCheckedBeforeSystemRevision, setIsCheckedBeforeSystemRevision] =
    useState<boolean>(businessState.job_114?.bReformJoinFlg === "1");
  // 制度改正後新設
  const [isCheckedAfterSystemRevision, setIsCheckedAfterSystemRevision] =
    useState<boolean>(businessState.job_114?.aReformJoinFlg === "1");
  // 退職者も検索
  const [isCheckedSearchRetiree, setIsCheckedSearchRetiree] = useState<boolean>(
    businessState.job_114?.retireFlg === "1"
  );

  // 施設区分１
  const [facilityKbn1, setFacilityKbn1] = useState<string>(
    businessState.job_114?.facilityKbn1 ?? ""
  );
  // 施設区分２
  const [facilityKbn2, setFacilityKbn2] = useState<string>(
    businessState.job_114?.facilityKbn2 ?? ""
  );
  // 加入条件１
  const [membershipStatus1, setMembershipStatus1] = useState<string>(
    businessState.job_114?.joinStatus1 ?? ""
  );
  // 加入条件２
  const [membershipStatus2, setMembershipStatus2] = useState<string>(
    businessState.job_114?.joinStatus2 ?? ""
  );
  // 加入日開始情報
  const [membershipDateFromCondition, setMembershipDateFromCondition] =
    useState<any>({
      membershipDateFrom: "",
    });
  // 加入日終了情報
  const [membershipDateToCondition, setMembershipDateToCondition] =
    useState<any>({
      membershipDateTo: "",
    });
  // 施設情報
  const [staffCondition, setStaffCondition] = useState<any>({
    staffNo: "",
    staffName: "",
    staffBirthday: "",
  });

  // 初期表示
  useEffect(() => {
    setContractorCondition({
      contractorNo: businessState.job_114?.searchContractorNo ?? "",
      contractorAddress: businessState.job_114?.contractorAddress ?? "",
      contractorNameKana: businessState.job_114?.corpNameKana ?? "",
      contractorName: businessState.job_114?.corpName ?? "",
      contractorTel: businessState.job_114?.tel ?? "",
      contractorFax: businessState.job_114?.fax ?? "",
    });
    setFacilityCondition({
      facilityNo: businessState.job_114?.searchFacilityNo ?? "",
      facilityAddress: businessState.job_114?.facilityAddress ?? "",
      facilityName: businessState.job_114?.facilityName ?? "",
    });
    setStaffCondition({
      staffNo: businessState.job_114?.searchStaffNo ?? "",
      staffName: businessState.job_114?.staffNameKanji ?? "",
      staffBirthday: businessState.job_114?.birthday ?? "",
    });
    setMembershipDateFromCondition({
      membershipDateFrom: businessState.job_114?.joinDateFrom ?? "",
    });
    setMembershipDateToCondition({
      membershipDateTo: businessState.job_114?.joinDateTo ?? "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 条件クリア
  const handleclearCondition = () => {
    setContractorCondition({
      contractorNo: "",
      contractorAddress: "",
      contractorNameKana: "",
      contractorName: "",
      contractorTel: "",
      contractorFax: "",
    });
    setFacilityCondition({
      facilityNo: "",
      facilityAddress: "",
      facilityName: "",
    });
    setStaffCondition({
      staffNo: "",
      staffName: "",
      staffBirthday: "",
    });
    setMembershipDateFromCondition({
      membershipDateFrom: "",
    });
    setMembershipDateToCondition({
      membershipDateTo: "",
    });
    setIsCheckedBeforeSystemRevision(false);
    setIsCheckedAfterSystemRevision(false);
    setIsCheckedSearchRetiree(false);
    setFacilityKbn1("");
    setFacilityKbn2("");
    setMembershipStatus1("");
    setMembershipStatus2("");
  };

  // 検索項目入力
  const handleChangeInput = (event: any, keyword: string, category: string) => {
    switch (category) {
      case "contractor":
        setContractorCondition({
          ...contractorCondition,
          contractorNo:
            keyword === "contractorNo"
              ? event.target?.value
              : contractorCondition.contractorNo,
          contractorAddress:
            keyword === "contractorAddress"
              ? event.target?.value
              : contractorCondition.contractorAddress,
          contractorNameKana:
            keyword === "contractorNameKana"
              ? event.target?.value
              : contractorCondition.contractorNameKana,
          contractorName:
            keyword === "contractorName"
              ? event.target?.value
              : contractorCondition.contractorName,
          contractorTel:
            keyword === "contractorTel"
              ? event.target?.valueForShow === "--"
                ? ""
                : event.target?.valueForShow
              : contractorCondition.contractorTel,
          contractorFax:
            keyword === "contractorFax"
              ? event.target?.valueForShow === "--"
                ? ""
                : event.target?.valueForShow
              : contractorCondition.contractorFax,
        });
        break;
      case "facility":
        setFacilityCondition({
          ...facilityCondition,
          facilityNo:
            keyword === "facilityNo"
              ? event.target?.value
              : facilityCondition.facilityNo,
          facilityAddress:
            keyword === "facilityAddress"
              ? event.target?.value
              : facilityCondition.facilityAddress,
          facilityName:
            keyword === "facilityName"
              ? event.target?.value
              : facilityCondition.facilityName,
        });
        break;
      case "staff":
        setStaffCondition({
          staffNo:
            keyword === "staffNo"
              ? event.target?.value
              : staffCondition.staffNo,
          staffName:
            keyword === "staffName"
              ? event.target?.value
              : staffCondition.staffName,
          staffBirthday:
            keyword === "staffBirthday"
              ? event.target?.value
              : staffCondition.staffBirthday,
        });
        break;
      case "membershipDateFrom":
        setMembershipDateFromCondition({
          membershipDateFrom:
            keyword === "membershipDateFrom"
              ? event.target?.value
              : membershipDateFromCondition.membershipDateFrom,
        });
        break;
      case "membershipDateTo":
        setMembershipDateToCondition({
          membershipDateTo:
            keyword === "membershipDateTo"
              ? event.target?.value
              : membershipDateToCondition.membershipDateTo,
        });
    }
  };

  useEffect(() => {
    setErrorList(handleErrorCheck());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractorCondition, facilityCondition, staffCondition]);

  // バリデーションチェック
  const handleErrorCheck = () => {
    const result = {
      contractorNo: "",
      contractorAddress: "",
      contractorNameKana: "",
      contractorName: "",
      contractorTel: "",
      contractorFax: "",
      facilityNo: "",
      facilityAddress: "",
      facilityName: "",
      staffNo: "",
      staffName: "",
      staffBirthday: "",
      membershipDateFrom: "",
      membershipDateTo: "",
    };
    // 契約者番号 文字長最大超過
    if (contractorCondition.contractorNo.length > 6) {
      result.contractorNo = TkPropertyMessageGet("TKMSG_SCR0046E", "6");
    }
    // 契約者番号 半角数字以外の入力
    if (!contractorCondition.contractorNo.match(/^[0-9]*$/)) {
      result.contractorNo = TkPropertyMessageGet("TKMSG_SCR0053E");
    }
    // 契約者所在地 文字長最大超過
    if (contractorCondition.contractorAddress.length > 85) {
      result.contractorAddress = TkPropertyMessageGet("TKMSG_SCR0046E", "85");
    }
    // 契約者所在地 全角以外の入力
    if (
      contractorCondition.contractorAddress !== "" &&
      !contractorCondition.contractorAddress.match(/^[^ -~｡-ﾟ]+$/)
    ) {
      result.contractorAddress = TkPropertyMessageGet("TKMSG_SCR0061E");
    }
    // 契約者名（ｶﾅ） 文字長最大超過
    if (contractorCondition.contractorNameKana.length > 85) {
      result.contractorNameKana = TkPropertyMessageGet("TKMSG_SCR0046E", "85");
    }
    // 契約者名（ｶﾅ）半角カナ以外の入力
    if (
      contractorCondition.contractorNameKana !== "" &&
      !contractorCondition.contractorNameKana.match(/^[ｧ-ﾝｦﾞﾟ\s-]*$/)
    ) {
      result.contractorNameKana = TkPropertyMessageGet("TKMSG_SCR0054E");
    }
    // 契約者名（漢字） 文字長最大超過
    if (contractorCondition.contractorName.length > 85) {
      result.contractorName = TkPropertyMessageGet("TKMSG_SCR0046E", "85");
    }
    // 契約者名（漢字）全角（アルファベット除く）以外の入力
    if (
      contractorCondition.contractorName !== "" &&
      !contractorCondition.contractorName.match(/^[^ -~｡-ﾟ]+$/)
    ) {
      result.contractorName = TkPropertyMessageGet("TKMSG_SCR0061E");
    }
    // 契約者電話番号 文字長最大超過
    if (contractorCondition.contractorTel?.length > 21) {
      result.contractorTel = TkPropertyMessageGet("TKMSG_SCR0046E", "21");
    }
    // 契約者FAX 文字長最大超過
    if (contractorCondition.contractorFax?.length > 13) {
      result.contractorFax = TkPropertyMessageGet("TKMSG_SCR0046E", "13");
    }
    // 施設番号 文字長最大超過
    if (facilityCondition.facilityNo?.length > 3) {
      result.facilityNo = TkPropertyMessageGet("TKMSG_SCR0046E", "3");
    }
    // 施設番号 半角数字以外の入力
    if (!facilityCondition.facilityNo?.match(/^[0-9]*$/)) {
      result.facilityNo = TkPropertyMessageGet("TKMSG_SCR0053E");
    }
    // 施設所在地 文字長最大超過
    if (facilityCondition.facilityAddress?.length > 85) {
      result.facilityAddress = TkPropertyMessageGet("TKMSG_SCR0046E", "85");
    }
    // 施設所在地 全角以外の入力
    if (
      facilityCondition.facilityAddress !== "" &&
      !facilityCondition.facilityAddress?.match(/^[^ -~｡-ﾟ]+$/)
    ) {
      result.facilityAddress = TkPropertyMessageGet("TKMSG_SCR0061E");
    }
    // 施設名 文字長最大超過
    if (facilityCondition.facilityName?.length > 85) {
      result.facilityName = TkPropertyMessageGet("TKMSG_SCR0046E", "85");
    }
    // 施設名 全角以外の入力
    if (
      facilityCondition.facilityName !== "" &&
      !facilityCondition.facilityName?.match(/^[^ -~｡-ﾟ]+$/)
    ) {
      result.facilityName = TkPropertyMessageGet("TKMSG_SCR0061E");
    }

    // 職員番号 文字長最大超過
    if (staffCondition.staffNo?.length > 5) {
      result.staffNo = TkPropertyMessageGet("TKMSG_SCR0046E", "5");
    }
    // 職員番号 半角数字以外の入力
    if (!staffCondition.staffNo?.match(/^[0-9]*$/)) {
      result.staffNo = TkPropertyMessageGet("TKMSG_SCR0053E");
    }
    // 職員名 文字長最大超過
    if (staffCondition.staffName?.length > 48) {
      result.staffName = TkPropertyMessageGet("TKMSG_SCR0046E", "48");
    }
    // 職員名全角（アルファベット除く）以外の入力
    if (
      staffCondition.staffName !== "" &&
      !staffCondition.staffName?.match(/^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/)
    ) {
      result.staffName = TkPropertyMessageGet("TKMSG_SCR0073E");
    }

    // 職員名生年月日 1900 / 01 / 01より前の日付
    if (
      staffCondition.staffBirthday !== "" &&
      Number(staffCondition.staffBirthday?.replaceAll("/", "") < 19000101)
    ) {
      result.staffBirthday = "1900 / 01 / 01より先の日付を入力してください";
    }

    // 職員名生年月日 2099 / 12 / 31より後の日付
    if (
      staffCondition.staffBirthday !== "" &&
      Number(staffCondition.staffBirthday?.replaceAll("/", "") > 20991231)
    ) {
      result.staffBirthday = "2099 / 12 / 31より前の日付を入力してください";
    }
    // 職員生年月日　日付形式
    if (
      staffCondition.staffBirthday &&
      !dayjs(staffCondition.staffBirthday, "YYYY/MM/DD", true).isValid()
    ) {
      result.staffBirthday = TkPropertyMessageGet("TKMSG_SCR0049E");
    }
    // 加入日開始 1900 / 01 / 01より前の日付
    if (
      membershipDateFromCondition.membershipDateFrom !== "" &&
      Number(
        membershipDateFromCondition.membershipDateFrom?.replaceAll("/", "") <
          19000101
      )
    ) {
      result.membershipDateFrom =
        "1900 / 01 / 01より先の日付を入力してください";
    }

    // 加入日開始 2099 / 12 / 31より後の日付
    if (
      membershipDateFromCondition.membershipDateFrom !== "" &&
      Number(
        membershipDateFromCondition.membershipDateFrom?.replaceAll("/", "") >
          20991231
      )
    ) {
      result.membershipDateFrom =
        "2099 / 12 / 31より前の日付を入力してください";
    }
    // 加入日開始　日付形式
    if (
      membershipDateFromCondition.membershipDateFrom &&
      !dayjs(
        membershipDateFromCondition.membershipDateFrom,
        "YYYY/MM/DD",
        true
      ).isValid()
    ) {
      result.membershipDateFrom = TkPropertyMessageGet("TKMSG_SCR0049E");
    }
    // 加入日終了 1900 / 01 / 01より前の日付
    if (
      membershipDateToCondition.membershipDateTo !== "" &&
      Number(
        membershipDateToCondition.membershipDateTo?.replaceAll("/", "") <
          19000101
      )
    ) {
      result.membershipDateTo = "1900 / 01 / 01より先の日付を入力してください";
    }
    // 加入日終了 2099 / 12 / 31より後の日付
    if (
      membershipDateToCondition.membershipDateTo !== "" &&
      Number(
        membershipDateToCondition.membershipDateTo?.replaceAll("/", "") >
          20991231
      )
    ) {
      result.membershipDateTo = "2099 / 12 / 31より前の日付を入力してください";
    }
    // 加入日終了　日付形式
    if (
      membershipDateToCondition.membershipDateTo &&
      !dayjs(
        membershipDateToCondition.membershipDateTo,
        "YYYY/MM/DD",
        true
      ).isValid()
    ) {
      result.membershipDateTo = TkPropertyMessageGet("TKMSG_SCR0049E");
    }

    return result;
  };

  const onSubmitAndCheck = () => {
    const validationCheckResult = handleErrorCheck();
    if (Object.values(validationCheckResult).some((value) => value !== "")) {
      setErrorList(validationCheckResult);
      return;
    }
    let resultType = "";
    let flgStaff = false;
    let flgFacility = false;
    let flgContractor = false;
    let flgIsCheckedBeforeSystemRevision = false;
    let flgIsCheckedAfterSystemRevision = false;
    let flgFacilityKbn1 = false;
    let flgFacilityKbn2 = false;
    let flgMembershipStatus1 = false;
    let flgMembershipDateFromCondition = false;
    let flgMembershipDateToCondition = false;
    let flgMembershipStatus2 = false;
    let flgIsCheckedSearchRetiree = false;

    if (Object.values(staffCondition).some((value) => value && value !== "")) {
      flgStaff = true;
    }
    if (
      Object.values(facilityCondition).some((value) => value && value !== "")
    ) {
      flgFacility = true;
    }
    if (
      Object.values(contractorCondition).some((value) => value && value !== "")
    ) {
      flgContractor = true;
    }

    if (isCheckedBeforeSystemRevision) {
      flgIsCheckedBeforeSystemRevision = true;
    }
    if (isCheckedAfterSystemRevision) {
      flgIsCheckedAfterSystemRevision = true;
    }
    if (Object.values(facilityKbn1).some((value) => value && value !== "")) {
      flgFacilityKbn1 = true;
    }
    if (Object.values(facilityKbn2).some((value) => value && value !== "")) {
      flgFacilityKbn2 = true;
    }
    if (
      Object.values(membershipStatus1).some((value) => value && value !== "")
    ) {
      flgMembershipStatus1 = true;
    }
    if (
      Object.values(membershipDateFromCondition).some(
        (value) => value && value !== ""
      )
    ) {
      flgMembershipDateFromCondition = true;
    }
    if (
      Object.values(membershipDateToCondition).some(
        (value) => value && value !== ""
      )
    ) {
      flgMembershipDateToCondition = true;
    }
    if (
      Object.values(membershipStatus2).some((value) => value && value !== "")
    ) {
      flgMembershipStatus2 = true;
    }
    if (isCheckedSearchRetiree) {
      flgIsCheckedSearchRetiree = true;
    }

    if (
      flgFacility ||
      flgIsCheckedBeforeSystemRevision ||
      flgIsCheckedAfterSystemRevision ||
      flgFacilityKbn1 ||
      flgFacilityKbn2
    ) {
      flgFacility = true;
    } else {
      flgFacility = false;
    }

    if (
      flgStaff ||
      flgMembershipStatus1 ||
      flgMembershipDateFromCondition ||
      flgMembershipDateToCondition ||
      flgMembershipStatus2 ||
      flgIsCheckedSearchRetiree
    ) {
      flgStaff = true;
    } else {
      flgStaff = false;
    }

    if (flgStaff) {
      resultType = "3";
    }
    if (!flgStaff && flgFacility) {
      resultType = "2";
    }
    if (!flgStaff && !flgFacility && flgContractor) {
      resultType = "1";
    }

    setBusinessState({
      ...businessState,
      job_114: {
        ...businessState.job_114,
        searchContractorNo: contractorCondition.contractorNo, //共済契約者番号
        contractorAddress: contractorCondition.contractorAddress, //契約者所在地
        corpNameKana: contractorCondition.contractorNameKana, //法人名（カナ）
        corpName: contractorCondition.contractorName, //法人名
        tel: contractorCondition.contractorTel, //共済契約者電話番号
        fax: contractorCondition.contractorFax, //共済契約者Fax番号
        searchFacilityNo: facilityCondition.facilityNo, //施設番号
        facilityAddress: facilityCondition.facilityAddress, //施設所在地
        facilityName: facilityCondition.facilityName, //施設名称
        bReformJoinFlg: isCheckedBeforeSystemRevision ? "1" : "", //制度改正前新設フラグ
        aReformJoinFlg: isCheckedAfterSystemRevision ? "1" : "", //制度改正後新設フラグ
        facilityKbn1: facilityKbn1, //施設区分①
        facilityKbn2: facilityKbn2, //施設区分②
        searchStaffNo: staffCondition.staffNo, //法人職員番号
        staffNameKanji: staffCondition.staffName, //法人職員氏名（漢字）
        birthday: staffCondition.staffBirthday, //法人職員生年月日
        joinStatus1: membershipStatus1, //加入状況①
        joinDateFrom: membershipDateFromCondition.membershipDateFrom, //加入日開始
        joinDateTo: membershipDateToCondition.membershipDateTo, //加入日終了
        joinStatus2: membershipStatus2, //加入状況②
        retireFlg: isCheckedSearchRetiree ? "1" : "", //退職フラグ
        detailDisplayCd: undefined,
        searchResultDisplayTarget:
          resultType === "3"
            ? InquiryResultDisplayType["職員"]
            : resultType === "2"
            ? InquiryResultDisplayType["施設"]
            : resultType === "1"
            ? InquiryResultDisplayType["法人"]
            : undefined, //検索結果表示対象
      },
    });
    navigate("/SCRW120002");
  };

  // 施設区分１
  const selectFacilityKbnList1Value1 = (e: any) => {
    setFacilityKbn1(e);
  };
  // 施設区分２
  const selectFacilityKbnList1Value2 = (e: any) => {
    setFacilityKbn2(e);
  };
  // 加入状況１
  const selectMembershipStatusValue1 = (e: any) => {
    setMembershipDateFromCondition({
      membershipDateFrom: "",
    });
    setMembershipDateToCondition({
      membershipDateTo: "",
    });
    setMembershipStatus1(e);
  };
  // 加入状況２
  const selectMembershipStatusValue2 = (e: any) => {
    setMembershipStatus2(e);
  };

  return (
    <Box data-testid="SCRW120001PageForTest" className="SCRW120001">
      <Box className="searchBox">
        <Box className="searchInfo mb20">
          <Box className="infoTitle">契約者情報</Box>

          <Box className="inputForm">
            <Box className="inputFormText">
              <TextField
                label="契約者番号"
                variant="standard"
                fullWidth
                onChange={(e) =>
                  handleChangeInput(e, "contractorNo", "contractor")
                }
                error={errorList["contractorNo"] !== "" || false}
                helperText={errorList["contractorNo"]}
                value={contractorCondition.contractorNo}
              />
            </Box>

            <Box className="inputFormText">
              <TextField
                label="契約者所在地"
                variant="standard"
                fullWidth
                onChange={(e) =>
                  handleChangeInput(e, "contractorAddress", "contractor")
                }
                error={errorList["contractorAddress"] !== "" || false}
                helperText={errorList["contractorAddress"]}
                value={contractorCondition.contractorAddress}
              />
            </Box>

            <Box className="inputFormText">
              <TextField
                label="契約者名（ｶﾅ）"
                variant="standard"
                fullWidth
                onChange={(e) =>
                  handleChangeInput(e, "contractorNameKana", "contractor")
                }
                error={errorList["contractorNameKana"] !== "" || false}
                helperText={errorList["contractorNameKana"]}
                value={contractorCondition.contractorNameKana}
              />
            </Box>

            <Box className="inputFormText">
              <TextField
                label="契約者名（漢字）"
                variant="standard"
                fullWidth
                onChange={(e) =>
                  handleChangeInput(e, "contractorName", "contractor")
                }
                error={errorList["contractorName"] !== "" || false}
                helperText={errorList["contractorName"]}
                value={contractorCondition.contractorName}
              />
            </Box>

            <Box className="inputFormText1">
              <label className="searchText">契約者電話番号</label>
            </Box>
            <Box className="searchTextMargin">
              <TkSuperPowerText
                type="phoneNum"
                onChange={(e: any) =>
                  handleChangeInput(e, "contractorTel", "contractor")
                }
                error={errorList["contractorTel"] !== "" || false}
                helperText={errorList["contractorTel"]}
                wantToSetValue={contractorCondition.contractorTel}
              />
            </Box>

            <Box className="inputFormText1">
              <label className="searchText">契約者FAX</label>
            </Box>
            <Box className="searchTextMargin">
              <TkSuperPowerText
                type="phoneNum"
                onChange={(e: any) =>
                  handleChangeInput(e, "contractorFax", "contractor")
                }
                error={errorList["contractorFax"] !== "" || false}
                helperText={errorList["contractorFax"]}
                wantToSetValue={contractorCondition.contractorFax}
              />
            </Box>
          </Box>
        </Box>
        <Box className="searchInfo mb20">
          <Box className="infoTitle">施設情報</Box>

          <Box className="inputForm">
            <Box className="inputFormText">
              <TextField
                label="施設番号"
                variant="standard"
                fullWidth
                onChange={(e) => handleChangeInput(e, "facilityNo", "facility")}
                error={errorList["facilityNo"] !== "" || false}
                helperText={errorList["facilityNo"]}
                value={facilityCondition.facilityNo}
              />
            </Box>

            <Box className="inputFormText">
              <TextField
                label="施設所在地"
                variant="standard"
                fullWidth
                onChange={(e) =>
                  handleChangeInput(e, "facilityAddress", "facility")
                }
                error={errorList["facilityAddress"] !== "" || false}
                helperText={errorList["facilityAddress"]}
                value={facilityCondition.facilityAddress}
              />
            </Box>

            <Box className="inputFormText">
              <TextField
                label="施設名"
                variant="standard"
                fullWidth
                onChange={(e) =>
                  handleChangeInput(e, "facilityName", "facility")
                }
                error={errorList["facilityName"] !== "" || false}
                helperText={errorList["facilityName"]}
                value={facilityCondition.facilityName}
              />
            </Box>

            <Box className="inputFormCheckBox">
              <TkCheckbox
                checked={isCheckedBeforeSystemRevision}
                label="制度改正前新設"
                onChange={(e: {
                  target: {
                    checked: boolean | ((prevState: boolean) => boolean);
                  };
                }) => {
                  setIsCheckedBeforeSystemRevision(e.target.checked);
                }}
              />
            </Box>

            <Box className="inputFormCheckBox">
              <TkCheckbox
                checked={isCheckedAfterSystemRevision}
                label="制度改正後新設"
                onChange={(e: {
                  target: {
                    checked: boolean | ((prevState: boolean) => boolean);
                  };
                }) => {
                  setIsCheckedAfterSystemRevision(e.target.checked);
                }}
              />
            </Box>

            <Box className="inputFormText">
              <TkSelectForm
                wantToSetValue={facilityKbn1}
                onGetValue={selectFacilityKbnList1Value1}
                selectPropsList={TkGetCodeList(FacilityKbnList1)}
                label={"施設区分①"}
                fullWidth
              />
            </Box>

            <Box className="inputFormText">
              <TkSelectForm
                wantToSetValue={facilityKbn2}
                onGetValue={selectFacilityKbnList1Value2}
                selectPropsList={TkGetCodeList(FacilityKbnList2)}
                label={"施設区分②"}
                fullWidth
              />
            </Box>
          </Box>
        </Box>
        <Box className="searchInfo">
          <Box className="infoTitle">職員情報</Box>

          <Box className="inputForm">
            <Box className="inputFormText">
              <TextField
                label="職員番号"
                variant="standard"
                fullWidth
                onChange={(e) => handleChangeInput(e, "staffNo", "staff")}
                error={errorList["staffNo"] !== "" || false}
                helperText={errorList["staffNo"]}
                value={staffCondition.staffNo}
              />
            </Box>

            <Box className="inputFormText">
              <TextField
                label="職員名"
                variant="standard"
                fullWidth
                onChange={(e) => handleChangeInput(e, "staffName", "staff")}
                error={errorList["staffName"] !== "" || false}
                helperText={errorList["staffName"]}
                value={staffCondition.staffName}
              />
            </Box>

            <Box className="inputFormDate">
              <TkDatePicker
                wantToSetValue={staffCondition.staffBirthday}
                onChange={(e: any) =>
                  handleChangeInput(e, "staffBirthday", "staff")
                }
                minDate={new Date("1900/1/1")}
                maxDate={new Date()}
                label={"職員生年月日"}
              />
            </Box>

            <Box className="inputFormText">
              <TkSelectForm
                wantToSetValue={membershipStatus1}
                onGetValue={selectMembershipStatusValue1}
                selectPropsList={TkGetCodeList(MembershipStatusList1)}
                label={"加入状況①"}
                fullWidth
              />
            </Box>

            {membershipStatus1 === "6" && (
              <Box className="inputFormDate">
                <TkDatePicker
                  wantToSetValue={
                    membershipDateFromCondition.membershipDateFrom
                  }
                  onChange={(e: any) =>
                    handleChangeInput(
                      e,
                      "membershipDateFrom",
                      "membershipDateFrom"
                    )
                  }
                  minDate={new Date("1900/1/1")}
                  maxDate={new Date()}
                  label={"加入日開始"}
                />
              </Box>
            )}

            {membershipStatus1 === "7" && (
              <Box className="inputFormDate">
                <TkDatePicker
                  wantToSetValue={membershipDateToCondition.membershipDateTo}
                  onChange={(e: any) =>
                    handleChangeInput(e, "membershipDateTo", "membershipDateTo")
                  }
                  minDate={new Date("1900/1/1")}
                  maxDate={new Date()}
                  label={"加入日終了"}
                />
              </Box>
            )}

            <Box className="inputFormText">
              <TkSelectForm
                wantToSetValue={membershipStatus2}
                onGetValue={selectMembershipStatusValue2}
                selectPropsList={TkGetCodeList(MembershipStatusList2)}
                label={"加入状況②"}
                fullWidth
              />
            </Box>

            <Box className="inputFormCheckBox">
              <TkCheckbox
                checked={isCheckedSearchRetiree}
                label="退職者も検索"
                onChange={(e: {
                  target: {
                    checked: boolean | ((prevState: boolean) => boolean);
                  };
                }) => {
                  setIsCheckedSearchRetiree(e.target.checked);
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className="btn">
        <TkButton onClick={() => handleclearCondition()}>条件クリア</TkButton>
        <TkButton onClick={() => onSubmitAndCheck()}>検索</TkButton>
      </Box>
    </Box>
  );
};

export default SCRW120001;
